import { render, staticRenderFns } from "./FormP1.vue?vue&type=template&id=9fb49de6&scoped=true"
import script from "./FormP1.vue?vue&type=script&lang=ts"
export * from "./FormP1.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=9fb49de6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb49de6",
  null
  
)

export default component.exports